import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as WorkPerformerActions from './work-performers.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class WorkPerformerStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new WorkPerformerActions.WorkPerformerRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.WORKPERFORMER, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new WorkPerformerActions.WorkPerformerCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new WorkPerformerActions.WorkPerformerUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new WorkPerformerActions.WorkPerformerDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new WorkPerformerActions.WorkPerformerRefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new WorkPerformerActions.WorkPerformerRefreshByID(data.id));
          break;
      }
    });
  }
}
